import {UserRolePagesMapping} from "./user-role-pages-mapping.model";
import {User} from "./User";
import {UserCounty} from "./UserCounty";
import {UserOffice} from "./UserOffice";
import {UserInformation} from "./UserInformation";
import {ProviderOffice} from "./ProviderOffice";
import {Role} from "./role.model";
import {ProviderCounty} from "./ProviderCounty";
import {WpProvider} from "./wp-provider.model";
import {UserRoles} from "./UserRoles";
import {StaffInfo} from "./StaffInfo";


export class StaffManagementRequest {
  constructor(
    public userId?: number,
    public userVOList?: UserVO[],
    public staffInfo?: StaffInfo,
    public providers?: WpProvider[],
    public providerCounties?: ProviderCounty[],
    public providerOffices?: ProviderOffice[],
    public roles?: Role[],

  ) {
  }
}

export class UserVO {
  constructor(
    public id?: number,
    public username?: string,
    public password?: string,
    public firstName?: string,
    public lastName?: string,
    public providerId?: number,
    public userCounties?: any[],
    public beginDt?: any,
    public endDt?: any,
    public tempPasswordSw?: any,
    public passwordExpirationDt?: any,
    public passwordExpirationTime?: any,
    public userRoles?: any[],
    public userOffices?: any[],
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/StaffManagementRequest.ts